import { Chip } from '@mint-lib/tw-components';
import { cn } from '@mint-lib/tw-utils';

import AnimatedVoice from './AnimatedVoice.jsx';

type Props = {
  className?: string;
  children: React.ReactNode;
  isActive: boolean;
};

const SpeakerChip = ({ className, children, isActive }: Props) => {
  return (
    <Chip
      className={cn(
        'flex h-8 w-fit max-w-52.5 gap-2 rounded-2xl bg-ui-tertiary px-2 py-1 text-text-primary hover:bg-ui-tertiary',
        className,
      )}
    >
      {children}
      <AnimatedVoice isActive={isActive} />
    </Chip>
  );
};

export default SpeakerChip;
